import { render, staticRenderFns } from "./AccreditationRenewBox.vue?vue&type=template&id=e5ba36cc&scoped=true"
import script from "./AccreditationRenewBox.vue?vue&type=script&lang=js"
export * from "./AccreditationRenewBox.vue?vue&type=script&lang=js"
import style0 from "./AccreditationRenewBox.vue?vue&type=style&index=0&id=e5ba36cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ba36cc",
  null
  
)

export default component.exports